import * as types from '../types/index'
import axios from 'axios'
import toast from 'react-hot-toast'
import config from '../config'
import { authHeader, header } from '../headers'

const url = config.testUrl

export const admin_login = (inputText, password) => async (dispatch) => {
	try {
		dispatch({ type: types.AUTH_REQUEST })

		const { data } = await axios.post(
			`${url}/admin/login`,
			{ inputText, password },
			{ headers: header }
		)

		if (data.status === 'ok') {
			dispatch({ type: types.AUTH_SUCCESS, payload: data.data })
			toast.success(`You are welcome, ${data.data.name}`, {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.AUTH_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const admin_logout = () => (dispatch) => {
	dispatch({ type: types.AUTH_LOGOUT })
	document.location.href = '/'
}

export const get_admin_profile = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_ADMIN_PROFILE_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		const { data } = await axios.get(`${url}/admin/${id}`, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_ADMIN_PROFILE_SUCCESS,
				payload: data.data,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.GET_ADMIN_PROFILE_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const refresh_admin_profile = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_ADMIN_PROFILE_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		const { data } = await axios.get(`${url}/admin/${id}`, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_ADMIN_PROFILE_SUCCESS,
				payload: data.data,
			})

			let passedData = {
				...data.data,
				token: detail.token,
				id: detail.id,
			}
			dispatch({
				type: types.AUTH_SUCCESS,
				payload: passedData,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.GET_ADMIN_PROFILE_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const update_admin_profile =
	(id, admin) => async (dispatch, getState) => {
		try {
			dispatch({ type: types.UPDATE_ADMIN_PROFILE_REQUEST })

			const {
				adminAuth: { detail },
			} = getState()

			const { data } = await axios.patch(`${url}/admin/${id}`, admin, {
				headers: authHeader(detail.token),
			})

			if (data.status === 'ok') {
				dispatch({
					type: types.UPDATE_ADMIN_PROFILE_SUCCESS,
					payload: data.data,
				})
				dispatch(refresh_admin_profile(data.data.id))
				toast.success('Your account has been updated!', {
					position: 'top-right',
				})
			}
		} catch (error) {
			const message = error.response
				? error.response.data.message
				: 'Something went wrong'
			if (message === 'Access Not Authorized' || message === 'Not Authorized') {
				dispatch(admin_logout())
			}
			dispatch({ type: types.UPDATE_ADMIN_PROFILE_FAIL, payload: message })
			toast.error(message, { position: 'top-right' })
		}
	}

// export const subadminregister = (user) => async (dispatch) => {
// 	try {
// 		dispatch({ type: types.USER_REGISTER_REQUEST })

// 		const { data } = await axios.post(`${url}/users`, user, {
// 			headers: header,
// 		})

// 		if (data.status === 'ok') {
// 			dispatch({
// 				type: types.USER_REGISTER_SUCCESS,
// 				payload: data,
// 			})
// 			toast.success('User Created Successfully!', {
// 				position: 'top-right',
// 			})
// 		}
// 	} catch (error) {
// 		const message = error.response
// 			? error.response.data.message
// 			: 'Something went wrong'
// 		if (message === 'Not Authorized') {
// 			dispatch(user_logout())
// 		}
// 		dispatch({ type: types.USER_REGISTER_FAIL, payload: message })
// 		toast.error(message, { position: 'top-right' })
// 	}
// }
